<template>
  <div id="app">
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <Vip msg="Welcome to Your Vue.js App" />
  </div>
</template>

<script>
//这里改了记得index.html的title也要改
// import HelloWorld from "./components/HelloWorld.vue";
import Vip from "./components/Vip.vue";

export default {
  name: "app",
  components: {
    Vip,
  },
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
body {
  background: #f4f4f4;
  margin: 0;
}
</style>
